import React, { useState, useEffect } from "react";
import { taxonomys } from "../../_services/taxonomys.service";
import { useTranslation } from "react-i18next";
import Select from "react-select";

export const Gender = ({ value, label, handler }) => {
  //Language hooks
  const { i18n, t } = useTranslation("common");
  const lang = i18n.language;
  const [gender, setGender] = useState([]);
  const options = [];
  useEffect(() => {
    /** Call Services  */
    taxonomys
      .getGender(lang)
      .then((res) => res.json())
      .then((response) => {
        if (response) {
          setGender(response);
        }
      })
      .catch(console.warn);
  }, [lang, setGender]);

  gender.map((item) => (
    options.push({
      value: item.id,
      label: t(item.category),
    })
  ));

  return (
    <>
      <label htmlFor="inputDescription" className="no__floating">
        {t("register.select_gender")}
      </label>
      <Select
        options={options}
        onChange={handler}
        defaultValue={{ value: label }}
      />
    </>
  );
};
